












































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  AdminRegisterMember,
  RegisterMember,
  EGroupRegisterType
} from '@/models'
import GroupMemberService from '@/services/GroupMemberService'
import { ERR_API_KEY } from '@/constants'
import AcceptanceService from '@/services/AcceptanceService'

@Component
export default class GroupRegister extends Vue {
  newMember: AdminRegisterMember = new AdminRegisterMember()
  passwordConfirm: string = ''
  registerType: EGroupRegisterType = Number(this.$route.query.type)
  private groupLink: string = this.$route.query.group as string
  private userUniqueUrl: string = this.$route.query.url as string
  eGroupRegisterType = EGroupRegisterType
  passwordMatch: boolean = true
  modalMess: string = ''
  email: string = ''
  isChecked: boolean = false
  term_url: string = process.env.VUE_APP_TERM_URL as string || ''
  policy_url: string = process.env.VUE_APP_POLICY_URL as string || ''
  isFormValid: boolean = false

  created() {
    this.init()
    this.getLatestVersion()
    if (this.registerType == this.eGroupRegisterType.USER_TEPM_REGISTER) {
      this.isChecked = true;
    }
  }

  getLatestVersion() {
    AcceptanceService.getLatestVersion().then((response) => {      
      this.term_url = response.data.term_url
      this.policy_url = response.data.policy_url      
    }).catch((error) => {
      console.log(error);
    })
  }

  /**
   * Check confirm password
   */
  @Watch('passwordConfirm')
  checkConfirmPassword() {
    if (this.passwordConfirm.localeCompare(this.newMember.password) === 0) {
      this.passwordMatch = true
      return
    }
    this.passwordMatch = false
  }

  /**
   * init
   */
  async init() {
    switch (this.registerType) {
      case EGroupRegisterType.ADMIN_REGISTER:
        if (!this.$route.params.groupId) {
          this.$router.push({ name: 'home' })
        }
        break
      case EGroupRegisterType.USER_REGISTER_INVITE:
      case EGroupRegisterType.USER_REGISTER_REQUEST_JOIN:
        const checkUrl = await this.handleUserUniqueUrl()

        //this case for check token true and use had logined
        if (this.$store.state.userInfo.user.info.id) {
          this.$router.push({ name: 'home' })
          break
        }

        //this case for token not expired but user have not login yet
        if (!checkUrl) {
          this.$router.push({
            name: 'login',
            query: {
              redirect: this.$route.fullPath
            }
          })
        }
        break
      case EGroupRegisterType.USER_TEPM_REGISTER:
        if (!this.groupLink) {
          this.$router.push({ name: 'home' })
        }
        break
      default:
        break
    }
  }

  /**
   * check user token
   */
  async handleUserUniqueUrl() {
    if (!this.userUniqueUrl) return false
    let check = false
    if (this.registerType === EGroupRegisterType.USER_REGISTER_INVITE) {
      check = await GroupMemberService.checkInvitedUserUniqueUrl(
        this.userUniqueUrl
      )
        .then(res => {
          if (res.data.is_valid && !res.data.is_temp_user) {
            this.$router.push({ name: 'login' })
            return true
          }

          return res.status === 200
        })
        .catch(err => {
          //this case for token expired
          if (err.response.status === 404) {
            this.$router.push({ name: 'token-expired' })
            return true
          }
          return false
        })
    } else if (
      this.registerType === EGroupRegisterType.USER_REGISTER_REQUEST_JOIN
    ) {
      check = await GroupMemberService.checkJoinRequestUserUniqueUrl(
        this.userUniqueUrl
      )
        .then(res => {
          return res.status === 200
        })
        .catch(err => {
          //this case for token expired
          if (err.response.status === 404) {
            this.$router.push({ name: 'token-expired' })
            return true
          }
          return false
        })
    }
    return check
  }

  @Watch('newMember.password')
  @Watch('passwordConfirm')
  @Watch('newMember.first_name')
  @Watch('newMember.last_name')
  @Watch('newMember.first_name_kana')
  @Watch('newMember.last_name_kana')
  @Watch('newMember.employee_number')
  onAnyInputChange() {
    this.checkFormValid()

    if (!this.isFormValid) {
      this.isChecked = false
    }
  }

  checkFormValid() {
    const {
      password,
      first_name,
      last_name,
      first_name_kana,
      last_name_kana,
      employee_number
    } = this.newMember
    const isNonEmpty = (...values: string[]) =>
      values.every(v => v && v.trim() !== '')

    if (this.registerType === this.eGroupRegisterType.ADMIN_REGISTER) {
      this.isFormValid = isNonEmpty(
        employee_number,
        password,
        first_name,
        last_name,
        first_name_kana,
        last_name_kana
      )
    } else if (
      [
        this.eGroupRegisterType.USER_REGISTER_INVITE,
        this.eGroupRegisterType.USER_REGISTER_REQUEST_JOIN
      ].includes(this.registerType)
    ) {
      this.isFormValid = isNonEmpty(
        password,
        this.passwordConfirm,
        first_name,
        last_name,
        first_name_kana,
        last_name_kana
      )
    }
  }

  get canSubmit(): boolean {
    return this.registerType === EGroupRegisterType.ADMIN_REGISTER || this.isChecked;
  }

  /**
   * Submit register form
   */
  submitRegister() {
    if (this.canSubmit) {
      this.newMember.group_id = this.$route.params.groupId
      switch (this.registerType) {
        case EGroupRegisterType.ADMIN_REGISTER:
          this.$blockui.show()
          GroupMemberService.registerAsMemberByAdmin(this.newMember)
            .then(res => {
              if (res.status === 200 || res.status === 201) {
                this.modalMess = this.$t('common.message.registered') as string
                this.$bvModal.show('modal-success')
              }
            })
            .catch(err => {
              const message = err.response.data.message
              const errCodeList = [
                ERR_API_KEY.GROUP_NOT_FOUND_OR_STOPPED,
                ERR_API_KEY.ERROR_MAX_REGISTERED_USER
              ]
              if (
                err.response.status === 422 &&
                err.response.data.errors['employee_number']
              ) {
                this.modalMess = this.$t(
                  'common.message.eid_already_used'
                ) as string
              } else {
                if (errCodeList.includes(message)) {
                  this.modalMess = this.$t(`common.message.${message}`) as string
                } else {
                  this.modalMess = this.$t('common.message.register_fail') as string
                }
              }
              this.$bvModal.show('modal-error')
            })
            .finally(() => this.$blockui.hide())
          break
        case EGroupRegisterType.USER_REGISTER_INVITE:
        case EGroupRegisterType.USER_REGISTER_REQUEST_JOIN:
          if (this.passwordMatch) {
            let newMem = new RegisterMember(this.newMember)
            newMem.type = this.registerType
            newMem.token = this.userUniqueUrl
            this.$blockui.show()
            GroupMemberService.registerAsMember(newMem)
              .then(res => {
                if (res.status === 200) {
                  this.modalMess = this.$t('common.message.registered') as string
                  this.$bvModal.show('modal-success')
                }
              })
              .catch(err => {
                const message = err.response.data.message
                const errCodeList = [
                  ERR_API_KEY.UPDATE_FROM_INVITE_LINK_FAIL,
                  ERR_API_KEY.GROUP_NOT_FOUND_OR_STOPPED,
                  ERR_API_KEY.ERROR_MAX_REGISTERED_USER
                ]
                if (errCodeList.includes(message)) {
                  this.modalMess = this.$t(`common.message.${message}`) as string
                } else {
                  this.modalMess = this.$t(
                    'common.message.register_fail'
                  ) as string
                }
                this.$bvModal.show('modal-error')
              })
              .finally(() => this.$blockui.hide())
          }
          break
        case EGroupRegisterType.USER_TEPM_REGISTER:
          this.$blockui.show()
          GroupMemberService.registerAsTempMember({
            email: this.email,
            group_link: this.groupLink,
            link_url: `${window.location.origin}/register?type=2&url=`
          })
            .then(res => {
              this.modalMess = this.$t('common.message.check_email') as string
              this.$bvModal.show('modal-success')
            })
            .catch(err => {
              if (
                [
                  ERR_API_KEY.WAIT_FOR_APPROVAL,
                  ERR_API_KEY.NOT_CHANGE_COMPANY,
                  ERR_API_KEY.USER_NOT_BE_LONG_TO_COMPANY,
                  ERR_API_KEY.USER_NOT_BELONG_TO_COMPANY,
                  ERR_API_KEY.ERROR_MAX_REGISTERED_USER
                ].includes(err.response.data.message)
              ) {
                this.modalMess = this.$t(
                  `common.message.${err.response.data.message}`
                ) as string
              } else if (err.response.status === 400) {
                this.modalMess = this.$t(
                  'common.message.user_already_actived'
                ) as string
              } else if (err.response.status === 422) {
                this.modalMess = this.$t(
                  'common.message.mail_already_used'
                ) as string
              } else if (err.response.status === 404) {
                this.modalMess = this.$t(
                  'common.message.GROUP_NOT_FOUND_OR_STOPPED'
                ) as string
              } else {
                this.modalMess = this.$t('common.message.register_fail') as string
              }
              this.$bvModal.show('modal-error')
            })
            .finally(() => this.$blockui.hide())
          break
        default:
          break
      }
    }
  }

  modalSuccessClose() {
    if (this.registerType === EGroupRegisterType.ADMIN_REGISTER) {
      window.close()
    } else {
      this.$router.push({ name: 'login' })
    }
  }
}
